import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SOURCES, getSmallImageSize, getImageUrl } from 'client/utils/image-helpers';
import { Image } from 'site-modules/shared/components/image/image';
import { ArrowLink } from 'site-modules/shared/components/arrow-link/arrow-link';

import './popular-search-card.scss';

export function PopularSearchCard({ content, className = '' }) {
  const { compareImage, compareImageAlt, compareUrl, compareUrlText } = content;
  const imageUrl = getImageUrl(compareImage, getSmallImageSize(compareImage), SOURCES.MEDIA);

  return (
    <div className={classnames('popular-search-card', className)}>
      <ArrowLink to={compareUrl} rel="nofollow" className="read-more-link">
        <Image imageId={imageUrl} alt={compareImageAlt} source={SOURCES.MEDIA} className="w-100" lazy ariaHidden />
        {compareUrlText}
      </ArrowLink>
    </div>
  );
}

PopularSearchCard.propTypes = {
  content: PropTypes.shape({
    compareImage: PropTypes.string.isRequired,
    compareImageAlt: PropTypes.string.isRequired,
    compareUrl: PropTypes.string.isRequired,
    compareUrlText: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};
